import React from "react";
import { Section } from "./Section";
import { ProjectCard } from "./ProjectCard";
import { projects } from "../../data/portfolio";

export const Projects = () => {
  const featured = projects.find((p) => p.featured) || projects[0];
  const rest = projects.filter((p) => p.slug !== featured.slug);

  return (
    <Section
      id="work"
      label="Selected Work"
      title="Pilihan sistem yang saya bangun, berfokus pada dampak — bukan sekadar kuantitas."
      index={3}
    >
      <div className="space-y-24 md:space-y-32">
        <ProjectCard project={featured} featured index={0} />

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8">
          {rest.map((p, i) => (
            <ProjectCard key={p.slug} project={p} index={i + 1} />
          ))}
        </div>
      </div>
    </Section>
  );
};

export default Projects;
